import React from 'react';
import { Box, Card, Grid, TextField, Typography } from '@mui/material';

const style = {
    p: 0,
    width: '98%',
    textAlign: 'left',
    marginLeft: '20px',
};

const ListHeaderDonantes = ({ filtros, setFiltros }) => {
    const handleChange = (field) => (e) => {
        setFiltros((prev) => ({
            ...prev,
            [field]: e.target.value,
        }));
    };

    return (
        <Box sx={style} component="form">
            <Grid container pt={1}>
                <Grid item xs={12} md={9}>
                    <Card
                        variant="outlined"
                        sx={{
                            backgroundColor: '#D9D9D9',
                        }}
                    >
                        <Grid
                            container
                            columnSpacing={5}
                            py={2}
                            px={2}
                            alignItems="flex-start"
                            justifyContent="flex-start"
                        >
                            <Grid item xs={12}>
                                <Typography color="primary" variant="h6">
                                    Filtros
                                </Typography>
                            </Grid>

                            <Grid item xs={2} md="auto">
                                <TextField
                                    label="Nombre del Donante"
                                    size="small"
                                    variant="standard"
                                    value={filtros.nombreDonante || ''}
                                    onChange={handleChange('nombreDonante')}
                                />
                            </Grid>

                            <Grid item xs={2} md="auto">
                                <TextField
                                    label="Promotor"
                                    size="small"
                                    variant="standard"
                                    value={filtros.promotor || ''}
                                    onChange={handleChange('promotor')}
                                />
                            </Grid>

                            <Grid item xs={2} md="auto">
                                <TextField
                                    label="Semana Preventa"
                                    size="small"
                                    type="number"
                                    variant="standard"
                                    value={filtros.semanaPreventa || ''}
                                    onChange={handleChange('semanaPreventa')}
                                />
                            </Grid>

                            <Grid item xs={2} md="auto">
                                <TextField
                                    label="Semana Cierre"
                                    size="small"
                                    type="number"
                                    variant="standard"
                                    value={filtros.semanaCierre || ''}
                                    onChange={handleChange('semanaCierre')}
                                />
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ListHeaderDonantes;
